// frontend/src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email, setEmail]     = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0E1B31 0%, #1F3B68 60%, #2C4F86 100%)',
    }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 20px' }}>
        {/* Logo */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 36 }}>
          <Logo size={34} variant="light" to={null} tagline="Performance Management" />
        </div>

        {/* Card */}
        <div style={{
          background: '#fff', borderRadius: 16, padding: '32px 28px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        }}>
          <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 18, marginBottom: 22 }}>
            Sign in
          </h2>

          {error && (
            <div style={{
              background: '#FCEBEB', color: '#A32D2D', fontSize: 13,
              padding: '10px 12px', borderRadius: 8, marginBottom: 16,
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 5, color: '#5F5E5A' }}>
                Email
              </label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@energin.com.au" required autoFocus
                style={{
                  width: '100%', padding: '9px 12px', fontSize: 13,
                  border: '0.5px solid rgba(0,0,0,0.14)', borderRadius: 8,
                  outline: 'none', color: '#1A1A18',
                }}
                onFocus={e => e.target.style.borderColor = '#1F3B68'}
                onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.14)'}
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 5, color: '#5F5E5A' }}>
                Password
              </label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" required
                style={{
                  width: '100%', padding: '9px 12px', fontSize: 13,
                  border: '0.5px solid rgba(0,0,0,0.14)', borderRadius: 8,
                  outline: 'none', color: '#1A1A18',
                }}
                onFocus={e => e.target.style.borderColor = '#1F3B68'}
                onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.14)'}
              />
            </div>

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '10px', background: '#1F3B68', color: '#fff',
              border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500,
              cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1,
              fontFamily: "'Poppins', sans-serif",
            }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Link to="/forgot-password" style={{ fontSize: 12, color: '#1F3B68', textDecoration: 'none' }}>
              Forgot password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
